export default "__VITE_ASSET__77e264f6__"